import type { UIEvent } from 'react';

const HIDE_DELAY_MS = 800;
const hideTimers = new WeakMap<Element, number>();

/**
 * `onScrollCapture` handler for a `.scrollbars-on-scroll` container. Marks the
 * element being scrolled with `data-scrolling` so its scrollbar shows, and
 * clears it shortly after scrolling stops. Capture phase catches every
 * scrolling descendant, since scroll events don't bubble.
 *
 * @param event - The scroll event from any element inside the container
 */
export function showScrollbarWhileScrolling(event: UIEvent<HTMLElement>) {
  const target = event.target;
  if (!(target instanceof Element)) return;
  target.setAttribute('data-scrolling', '');
  window.clearTimeout(hideTimers.get(target));
  hideTimers.set(
    target,
    window.setTimeout(() => {
      target.removeAttribute('data-scrolling');
      hideTimers.delete(target);
    }, HIDE_DELAY_MS),
  );
}
